import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/jobs/create")({
  beforeLoad: () => {
    throw redirect({
      to: "/jobs/new-reception",
      replace: true,
    })
  },
})
